import { render, staticRenderFns } from "./InventoryDashboard.vue?vue&type=template&id=28d9d0d8&scoped=true&"
import script from "./InventoryDashboard.vue?vue&type=script&lang=js&"
export * from "./InventoryDashboard.vue?vue&type=script&lang=js&"
import style0 from "./InventoryDashboard.vue?vue&type=style&index=0&id=28d9d0d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d9d0d8",
  null
  
)

export default component.exports